import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import AdminLayout from "./AdminLayout";

function Stat({ label, value, sublabel, testid }) {
    return (
        <div className="bg-surface border border-ink/10 rounded-2xl p-5" data-testid={testid}>
            <div className="text-xs text-ink-muted uppercase tracking-wider">{label}</div>
            <div className="font-serif text-3xl mt-2">{value}</div>
            {sublabel && <div className="text-xs text-ink-muted mt-1">{sublabel}</div>}
        </div>
    );
}

export default function AdminRetention() {
    const [d, setD] = useState(null);
    useEffect(() => {
        api.get("/admin/retention").then((r) => setD(r.data)).catch(() => {});
    }, []);
    if (!d) return <AdminLayout title="Retention"><div className="text-ink-muted">Loading…</div></AdminLayout>;
    return (
        <AdminLayout title="User Retention" subtitle="How frequently users return and engage with StarPath.">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="admin-retention-grid">
                <Stat testid="ret-active-today" label="Active Today" value={d.active_today} />
                <Stat testid="ret-active-7d" label="Active · 7 Days" value={d.active_7d} />
                <Stat testid="ret-active-30d" label="Active · 30 Days" value={d.active_30d} />
                <Stat testid="ret-returning" label="Returning Users" value={d.returning_users} sublabel="≥ 2 logins in 30d" />
                <Stat testid="ret-sessions" label="Avg Sessions / User" value={d.avg_sessions_per_user} />
                <Stat testid="ret-recs" label="Avg Recs Viewed" value={d.avg_recommendations_viewed} />
                <Stat testid="ret-saves" label="Avg Destinations Saved" value={d.avg_destinations_saved} />
                <Stat testid="ret-conversion" label="Rec → Save Rate" value={`${d.recommendation_conversion_rate}%`} />
                <Stat testid="ret-flight-rate" label="Rec → Flight Click" value={`${d.flight_search_click_rate}%`} />
                <Stat testid="ret-total" label="Total Users" value={d.total_users} />
            </div>
        </AdminLayout>
    );
}
